/// <reference path="../types/index.d.ts" />

import '../client_forms/mculinary2/style.css';
import FormStructure from './mculinary2/form_structure';

export default FormStructure;